import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';

import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as io from 'socket.io-client';
import { environment } from '../environments/environment';
import { Speaker } from './models/speaker';

@Injectable()
export class SpeakerService {

  socket: any = null;

  MODE = 'RES';
  limit = 50;

  base_url: String = environment.API_BASE_URL;
  speakers = [];
  stats: Object;
  statsLoading = false;
  activeSearch = false;
  term: string;
  instances = [];
  instancesWriting = [];
  state: Object = {};
  instanceChange: Subject<string> = new Subject<string>();
  searchChange: Subject<boolean> = new Subject<boolean>();
  statsChange: Subject<any> = new BehaviorSubject<any>({});
  speakersChange: Subject<any> = new BehaviorSubject<any>([]);
  tabChange: Subject<any> = new BehaviorSubject<any>({});
  removedInstances: Array<Object> = new Array<Object>();
  socketid: string;
  searching: string;
  progress: any;
  progressSubject: Subject<any> = new Subject<any>();

  concordanceGenreFilter: BehaviorSubject<any> = new BehaviorSubject<any>({});
  concordanceGenderFilter: BehaviorSubject<any> = new BehaviorSubject<any>({});
  concordanceClassFilter: BehaviorSubject<any> = new BehaviorSubject<any>({});
  concordanceAgeFilter: BehaviorSubject<any> = new BehaviorSubject<any>({});
  concordanceClearFilter: BehaviorSubject<any> = new BehaviorSubject<any>({});
  concordanceCorpusFilter: BehaviorSubject<any> = new BehaviorSubject<any>({});
  concordanceMapFilter: BehaviorSubject<any> = new BehaviorSubject<any>({});

  filters = [];
  filterValues = { 'age group': [], 'gender': [], 'area': [], 'source': [], 'social class': [] };

  pass: string = "";

  constructor(private http: Http) {

    if (environment.SOCKET_URL) {
      this.socket = io(environment.SOCKET_URL, { 'timeout': 60000 });
    } else {
      this.socket = io();
    }
    const self = this;

    this.getFilters().subscribe(res => {
      this.filters = res;
      this.filters.map(group => {
        group.values.map(
          val => { this.filterValues[group['name']].push(val); });
      });
    });

    this.socket.on('reload', function () { });
    this.socket.on('speakers', function (speakers) {
      self.speakers = speakers;
      self.speakersChange.next(self.speakers);
    });

    this.socket.on('id', function (id) {
      self.socketid = id;
    });

    this.socket.on('stats', function (res) {
      if (res != null) {
        self.stats = res['stats'];
        self.speakers = res['speakers'];
        this.statsLoading = false;
        self.activeSearch = false;
        //self.state['totalDocs'] = self.stats['total'];
        self.statsChange.next(self.stats);
        self.speakersChange.next(self.speakers);
        for (let idx of Object.keys(self.progress)) {
          self.progress[idx]['start'] = self.progress[idx]['total'];
        }
        self.progressSubject.next();
      }
    });

    this.socket.on("docs", function (res) {
      if (res.term == self.searching) {
        self.state = {};
        self.instances = res['sentences'];
        self.instancesWriting = res['sentencesWriting'];
        self.state['countWriting'] = res.countWriting;
        self.state['totalDocsWriting'] = res.totalDocsWriting;
        self.state['rowsWriting'] = res.totalDocsWriting;
        self.state['count'] = res.count;
        self.state['totalDocs'] = res.totalDocs;
        self.state['start'] = res.start;
        self.state['end'] = res.end;
        self.state['rows'] = res.totalDocs;
        for (let i = 0; i < self.instances.length; i++) {
          self.instances[i].index = i + 1;
        }
        for (let i = 0; i < self.instancesWriting.length; i++) {
          self.instancesWriting[i].index = i + 1;
        }
      }
    });

    this.socket.on("avgInit", function (obj) {
      self.progress[obj.index] = { total: obj.total, start: obj.start };
    });

    this.socket.on("progress", function (obj) {
      if (self.progress[obj.index]) {
        self.progress[obj.index]["start"] = obj.start;
        self.progressSubject.next();
      }
    });

    this.socket.on("partDocs", function (res) {
      if (res.term == self.searching) {
        self.instances = self.instances.concat(res['sentences']);
        self.instancesWriting = self.instancesWriting.concat(res['sentencesWriting']);
        self.state['countWriting'] += res.countWriting;
        self.state['totalDocsWriting'] += res.totalDocsWriting;
        self.state['endWriting'] += res.countWriting;
        self.state['rowsWriting'] = self.instancesWriting.length;
        self.state['count'] += res.count;
        self.state['totalDocs'] += res.totalDocs;
        self.state['end'] += res.count;
        self.state['rows'] = self.instances.length;
        if (res.aggrgteWordTotalFlag) {
          self.state['wordsWriting'] += res.wordTotalWriting;
          self.state['words'] += res.wordTotal;
        }
        console.log(res.count, res.wordTotal, res.sentences);
        for (let i = self.instances.length; i > 0; i--) {
          self.instances[i - 1].index = i;
        }
        for (let i = self.instancesWriting.length; i > 0; i--) {
          self.instancesWriting[i - 1].index = i;
        }
        self.instanceChange.next();
      } else {
        self.instancesWriting = [];
        self.instances = [];
        self.state['countWriting'] = 0;
        self.state['totalDocsWriting'] = 0;
        self.state['rowsWriting'] = 0;
        self.state['wordsWriting'] = 0;
        self.state['count'] = 0;
        self.state['totalDocs'] = 0;
        self.state['start'] = 0;
        self.state['end'] = 0;
        self.state['rows'] = 0;
        self.state['words'] = 0;
        self.progress = {};
      }
    });

    this.socket.on("disconnect", function () {
      /*  		self.searching = '';
               self.instances = [];
             self.state['count'] = 0;
             self.state['start'] = 0;
             self.state['end'] = 0;
             self.state['rows'] = 0;
             self.state['words'] = 0;
             self.stats = null;
             self.progress = {}; */
    });
  }

  search(terms: Observable<string>) {
    return terms.debounceTime(500).switchMap(term => {
      this.term = term;
      if (term && term.length > 0) {
        return this.searchEntries(term);
      } else {
        console.log('empty');
        this.activeSearch = false;
        this.speakers = [];
        this.stats = null;
        this.state = {};
        this.instancesWriting = [];
        this.instances = [];
        this.progress = {};
        return Observable.from([{ msg: 'no data', term: '' }]);
      }
    });
  }


  //  handleTabChange(event) {
  //    this.tabChange.next(event);
  //  }

  searchEntries(query: string, sid = undefined, skip = 0, limit = this.limit) {
    if (this.socket == undefined) {
      setTimeout(function () {
        this.searchEntries(query, sid, skip, limit);
      }, 1);
      return;
    }
    console.log(query);
    let speaker: Speaker[];
    let params: string = `term=${query}`;
    let queryUrl: string = `${this.base_url}sentences/search?${params}`;
    if (sid) {
      // queryUrl = `${this.base_url}speaker/search?${params}`;
    }
    this.activeSearch = true;
    this.changeView('RES', {});
    const options = new RequestOptions({
      headers: new Headers(
        { 'Accept': 'application/json', 'Accept-Encoding': 'gzip' })
    });
    console.log(this.filterValues);
    let body = { 'term': query, 'filters': this.filterValues, 'page': skip, 'limit': limit, 'socketid': this.socketid };
    if (sid) {
      body['id'] = sid;
    }
    this.searching = query;
    this.instancesWriting = [];
    this.instances = [];
    this.state = {};
    this.state['countWriting'] = 0;
    this.state['totalDocsWriting'] = 0;
    this.state['rowsWriting'] = 0;
    this.state['wordsWriting'] = 0;
    this.state['count'] = 0;
    this.state['totalDocs'] = 0;
    this.state['start'] = 0;
    this.state['end'] = 0;
    this.state['rows'] = 0;
    this.state['words'] = 0;
    this.stats = null;
    this.speakers = [];
    this.progress = {};
    this.progressSubject.next();
    return this.http.post(queryUrl, body)
      .map(response => {
        if (response['status'] === 200) {
          const res = response.json();
          console.log(res);
          return {
            msg: 'data loaded',
            term: query,
            count: 0,
            filters: 0
          };
        } else {
          this.speakers = [];
          this.stats = {};
          this.instancesWriting = [];
          this.instances = [];
          return { msg: 'no data', term: '' };
        }
      });
  }
  /*
    exportCSV(query: string, sid = undefined, skip = 0, limit = this.limit) {
      query =  this.term;
      let speaker: Speaker[];
      let queryUrl: string = `${this.base_url}sentences/csv`;
      const options = new RequestOptions({
        headers : new Headers(
            {'Accept' : 'application/csv', 'Accept-Encoding' : 'gzip'})
      });
      console.log(options);
      let body = {'term': query, 'filters' : this.filterValues, 'page': skip, 'limit': limit}
      if (sid) {
        body['id'] = sid;
      }
      this.http.post(queryUrl, body)
          .subscribe(response => {
            if (response['status'] === 200) {
              console.log(response);
              var encodedUri = encodeURI(response.text());
              let parsedResponse = response.text();
              let blob = new Blob([parsedResponse], { type: 'text/csv' });
              let url = window.URL.createObjectURL(blob);
              let file = 'results.csv';
              if (navigator.msSaveOrOpenBlob) {
                  navigator.msSaveBlob(blob, file);
              } else {
                  let a = document.createElement('a');
                  a.href = url;
                  a.download = file;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
              }
              window.URL.revokeObjectURL(url);
            }
          });
    }*/

  getFilters() {
    let queryUrl: string = `${this.base_url}sentences/filters`;
    return this.http.get(queryUrl).map(response => {
      let res = response.json();

      return res;
    });
  }

  clearFilters(searchTerm) {
    this.getFilters().subscribe(res => {
      this.filters = res;
      this.filters.map(group => {
        group.values.map(
          val => { this.filterValues[group['name']].push(val); });
      });
    });
  }

  removeInstance(personId, rowIndex) {
    this.removedInstances.push(
      { sid: personId, line: this.instances[personId][rowIndex] });
    this.instances[personId].splice(rowIndex, 1);
    this.instanceChange.next(personId);
  }

  switchInstances(concord) {
    for (let i = 0; i < this.instances.length; i++) {
      this.instances[i]['concordance'] = concord;
    }
    this.instanceChange.next(concord);
  }

  switchInstance(offset, inst, concord) {
    const found = this.instances.findIndex(found => {
      if (inst.sentence === found.sentence) {
        return found;
      }
    });
    if (found > 0) {
      const server_index = found + offset;
      let params: string = `index=${server_index}&enabled=${concord}`;
      let queryUrl: string = `${this.base_url}sentences/include?${params}`;
      // this.activeSearch = true;
      var options = new RequestOptions({
        headers: new Headers(
          { 'Accept': 'application/json', 'Accept-Encoding': 'gzip' })
      });
      this.http.get(queryUrl).subscribe(response => {
        this.socket.emit('speaker_request');
        this.socket.emit('stats_request', '');
        this.instances[found] = response.json().message;
      });
    }
  }

  getSpeaker(sid): Speaker {
    let found = undefined;
    this.speakers.forEach(speaker => {
      if (speaker.sid === sid) {
        found = speaker;
      }
    });
    return found;
  }

  getSpeakerIndex(sid): number {
    let found = undefined;
    for (let i = 0; i < this.speakers.length; i++) {
      if (this.speakers[i].sid === sid) {
        found = i;
        break;
      }
    }

    return found;
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    this.activeSearch = false;
    return Promise.reject(error.message || error);
  }

  changeView(mode, event) {
    this.MODE = mode;
    this.concordanceClearFilter.next({});
    this.tabChange.next(this.MODE);
  }

  doTest(speakers) {
    let url = environment.API_URL + "bnclab/anova.php?type=anova";
    let params = new URLSearchParams();
    params.append("grp1", encodeURIComponent(JSON.stringify(speakers).replace("[", "").replace("]", "")));
    return this.http.post(url, params);
  }
}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/speaker.service.ts